import React from 'react';
import './progressBar.style.scss'; // Assuming you have a CSS file for styling

const ProgressBar = ({ percentageCompletion }) => {
    return (
        <div className="progress-bar-container">
            <div className="progress-bar" style={{ width: `${percentageCompletion}%` }}></div>
        </div>
    );
};

export default ProgressBar;
